import classnames from "classnames";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { TeamMember, Teams, ModalDeleteIcon } from "components/assets/Icons";
import FormField, { STYLE } from "components/FormField";
import TeamMembers from "pages/Profile/components/TeamMembers";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import { addTeam, deleteTeam, editTeams, profileTeams } from "actions/teams";

import styles from "./Modals.module.scss";

export const ModalEdit = ({ data, setShowModal }) => {
  const dispatch = useDispatch();
  const [teamValue, setTeamValue] = useState(data.name);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    dispatch(editTeams(data.id, teamValue));

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Edit Team</h2>
      <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
        <FormField
          labelText="Team"
          value={teamValue}
          icon={<Teams />}
          style={STYLE.MODAL}
          onChange={(e) => setTeamValue(e.target.value)}
        />

        <FormField
          labelText="Team Members"
          value={`${data.members?.length} selected`}
          icon={<TeamMember />}
          style={STYLE.MODAL}
          disabled={true}
        />

        <div className={styles.group}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.NONE}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button size={VIEW.MIDDLE} type="submit">
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export const ModalAdd = ({ setShowModal }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [teamValue, setTeamValue] = useState("");
  const [employeesPhotos, setEmployeesPhotos] = useState(new Map());

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const membersId = selected.map(({ id }) => {
      return id;
    });

    dispatch(addTeam(teamValue, membersId)).then(() => {
      dispatch(profileTeams);
    });

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>Add Team</h2>
      <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
        <FormField
          labelText="Team"
          value={teamValue}
          icon={<Teams />}
          style={STYLE.MODAL}
          onChange={(e) => setTeamValue(e.target.value)}
        />

        <TeamMembers
          selected={selected}
          setSelected={setSelected}
          employeesPhotos={employeesPhotos}
          setEmployeesPhotos={setEmployeesPhotos}
        />

        <div className={styles.group}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.NONE}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button size={VIEW.MIDDLE} type="submit">
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export const ModalDelete = ({ data, setShowModal, setTeamsList }) => {
  const dispatch = useDispatch();

  const handleOnClick = (e) => {
    e.preventDefault();

    dispatch(deleteTeam(data)).then(() => {
      dispatch(profileTeams);
    });

    setTimeout(() => setShowModal(false), 500);
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Delete Team</h2>
      <p className={styles.description}>
        Do you really want to delete this team? This process cannot be undone.
      </p>
      <div className={styles.group}>
        <Button size={VIEW.MIDDLE} color={COLOR.NONE} onClick={() => setShowModal(false)}>
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleOnClick}>
          Delete
        </Button>
      </div>
    </div>
  );
};
